import type { ButtonHTMLAttributes, ReactNode } from 'react';

import styles from './button.module.css';

export type ButtonVariant = 'primary' | 'secondary' | 'neutral' | 'ghost' | 'danger';

export interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  readonly variant?: ButtonVariant;
  readonly isBusy?: boolean;
  readonly busyLabel?: string;
  readonly block?: boolean;
  readonly children: ReactNode;
}

/**
 * Botón del sistema. Mientras está ocupado se deshabilita y anuncia el estado
 * a lectores de pantalla, de modo que un doble envío es imposible por diseño.
 */
export function Button({
  variant = 'primary',
  isBusy = false,
  busyLabel = 'Guardando...',
  block = false,
  disabled,
  children,
  type = 'button',
  className,
  ...rest
}: Readonly<ButtonProps>) {
  const classes = [styles.base, styles[variant], block ? styles.block : '', className ?? '']
    .filter(Boolean)
    .join(' ');

  return (
    <button
      {...rest}
      aria-busy={isBusy}
      className={classes}
      disabled={disabled === true || isBusy}
      type={type}
    >
      {isBusy ? busyLabel : children}
    </button>
  );
}
